import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { makeBoxShadow } from '../../../src/shared/helpers/shadowStyles.helper';

export const getFriendStatsBannerStyles = (theme: Theme) =>
  StyleSheet.create({
    h2hCard: {
      backgroundColor: theme.background.card,
      borderRadius: 16,
      marginHorizontal: 16,
      marginTop: 4,
      marginBottom: 16,
      padding: 20,
      ...makeBoxShadow({ shadowColor: theme.shadow, shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.06, shadowRadius: 12 }),
      elevation: 3,
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    h2hHeaderRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 20,
      paddingBottom: 12,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[200],
    },
    h2hTitle: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.gray[600],
      textTransform: 'uppercase',
      letterSpacing: 1.5,
    },
    h2hStatRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 16,
    },
    h2hStatRowLast: {
      marginBottom: 0,
    },
    h2hStatCell: {
      flex: 1,
      alignItems: 'center',
    },
    h2hStatValue: {
      fontSize: 26,
      fontWeight: '800',
      color: theme.black,
      lineHeight: 32,
    },
    h2hStatValueWins: {
      fontSize: 26,
      fontWeight: '800',
      color: theme.black,
      lineHeight: 32,
    },
    h2hStatValueUser: {
      fontSize: 22,
      fontWeight: '800',
      color: theme.info,
      lineHeight: 28,
    },
    h2hStatValueFriend: {
      fontSize: 22,
      fontWeight: '800',
      color: theme.error,
      lineHeight: 28,
    },
    h2hStatLabel: {
      fontSize: 10,
      fontWeight: '600',
      color: theme.gray[500],
      textTransform: 'uppercase',
      letterSpacing: 0.8,
      marginTop: 2,
    },
    h2hIconCenter: {
      width: 36,
      height: 36,
      borderRadius: 18,
      backgroundColor: theme.gray[100],
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: 12,
    },
    h2hIconCenterGold: {
      width: 36,
      height: 36,
      borderRadius: 18,
      backgroundColor: theme.warning + '25',
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: 12,
    },
    h2hIconCenterStar: {
      width: 36,
      height: 36,
      borderRadius: 18,
      backgroundColor: theme.primary + '18',
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: 12,
    },
    h2hBarCell: {
      flex: 1,
      alignItems: 'center',
    },
    h2hBarBg: {
      width: '80%',
      height: 6,
      borderRadius: 3,
      backgroundColor: theme.gray[200],
      overflow: 'hidden',
    },
    h2hBarFillUser: {
      height: '100%',
      borderRadius: 3,
      backgroundColor: theme.info,
      minWidth: 4,
    },
    h2hBarFillFriend: {
      height: '100%',
      borderRadius: 3,
      backgroundColor: theme.success,
      minWidth: 4,
    },
    h2hBarLabel: {
      fontSize: 10,
      fontWeight: '600',
      color: theme.gray[600],
      marginTop: 4,
    },
  });
